import { TokenWithValue } from '@/domain/common/types'
import { SuccessViewPanelTitle } from '@/features/dialogs/common/components/success-view/SuccessPanelTitle'
import { SuccessViewCheckmark } from '@/features/dialogs/common/components/success-view/SuccessViewCheckmark'
import { SuccessViewContent } from '@/features/dialogs/common/components/success-view/SuccessViewContent'
import { SuccessViewPanel } from '@/features/dialogs/common/components/success-view/SuccessViewPanel'
import { SuccessViewProceedButton } from '@/features/dialogs/common/components/success-view/SuccessViewProceedButton'
import { SuccessViewTokenRow } from '@/features/dialogs/common/components/success-view/SuccessViewTokenRow'
import { testIds } from '@/ui/utils/testIds'

export interface SuccessViewProps {
  tokenToDeposit: TokenWithValue
  closeDialog: () => void
}
export function SuccessView({ tokenToDeposit, closeDialog }: SuccessViewProps) {
  const { token, value } = tokenToDeposit

  return (
    <SuccessViewContent>
      <SuccessViewCheckmark />
      <SuccessViewPanel data-testid={testIds.dialog.success}>
        <SuccessViewPanelTitle>Deposited</SuccessViewPanelTitle>
        <SuccessViewTokenRow token={token} amount={value} />
      </SuccessViewPanel>
      <SuccessViewProceedButton onProceed={closeDialog}>Back to savings</SuccessViewProceedButton>
    </SuccessViewContent>
  )
}
